import EightByEightCreate from 'pages/services/new/ServiceWizard/EightByEightCreate';

export default function AddEightByEight({ serviceWizard }) {
    return <EightByEightCreate serviceWizard={serviceWizard} />;
}
